import React from "react";
import * as styles from "./list.module.scss";

export type ListItemData =
  | string
  | {
      bold?: string;
      prefix?: string;
      text?: string;
      link?: string;
      linkUrl?: string;
      suffix?: string;
    };

interface ListItemProps {
  data: ListItemData;
  size?: "small";
}

export const ListItem: React.FC<ListItemProps> = ({ data, size }) => (
  <li className={`${styles.item}${size === "small" ? ` ${styles.itemSmall}` : ""}`}>
    {typeof data === "string" ? (
      data
    ) : (
      <>
        {data.prefix}
        {data.bold && <strong className={styles.bold}>{data.bold}</strong>}
        {data.text}
        {data.link && (
          <a href={data.linkUrl} className={styles.link}>
            {data.link}
          </a>
        )}
        {data.suffix}
      </>
    )}
  </li>
);
